module.exports = __webpack_public_path__ + "static/media/XK.60673b18.svg";